import OverviewStatementsCardsTransaction from '../overview-statements/overview-statements-cards-transaction';
import { CardPaymentSystem } from '../../../hoc/customers/types';
import { CardsTransactionsTypes } from './types';

import cn from './cards.module.css';

const CardsTransactions = ({
  cards,
  cardId,
  setCardId,
  onSort,
  onFilter,
  cardsTransactions,
  filters,
  sort,
  requestInProgress,
}: CardsTransactionsTypes) => (
  <div className={cn.cardsTransactions}>
    <div className={cn.cardsTransactionsTitle}>Transactions</div>
    <div className={cn.cardsTransactionsTabs}>
      {cards?.map((item) => (
        <button
          type="button"
          key={item.id}
          onClick={() => setCardId(item.id)}
          className={`${cn.cardsTransactionsTab} ${
            cardId === item.id ? cn.cardsTransactionsTabActive : ''
          }`}
          title={`${
            item.paymentSystem === CardPaymentSystem.MASTER_CARD ? 'MC' : 'VISA'
          } ${item.type} ${item.number}`}
        >
          {`${
            item.paymentSystem === CardPaymentSystem.MASTER_CARD ? 'MC' : 'VISA'
          } ${item.type} ${item.number}`}
        </button>
      ))}
    </div>
    <OverviewStatementsCardsTransaction
      onSort={onSort}
      onFilter={onFilter}
      cardsTransactions={cardsTransactions}
      filters={filters}
      sort={sort}
      requestInProgress={requestInProgress}
    />
  </div>
);

export default CardsTransactions;
